export default __webpack_public_path__ + "static/media/Healthy_Food_16_9.6280d1f6.png";